<template>
    <div id="you-might-also-like">
        <div class="text-center my-5 d-none d-lg-block" v-if="currentStore">
            <div class="row justify-content-center">
                <div class="col-12">
                    <h1 class="carousel-title text-center font-weight-bold">You Might Also Like</h1>
                </div>
                <div class="row justify-content-center">
                    <carousel
                            class="vue-carousel-area"
                            :loop="true" :perPage="3"
                            :paginationEnabled="false"
                            :navigationEnabled="true"
                            :scrollPerPage="false"
                            navigationNextLabel="<img src='/images/carousel/right-arrow.svg'>"
                            navigationPrevLabel="<img src='/images/carousel/left-arrow.svg'>"
                    >
                        <slide v-for="p in products" :key="p.id">
                            <router-link
                                    :to="`/jewelers/${currentStore.url}/product/${$route.name === 'product-diamond' ? 'diamond' : 'ring'}/${p.internal_lot}`">
                                <div class="carousel-element-area">
                                    <img :src="p.Media.find(m => m.type === 'thumbnail-md').src" :alt="p.name" class="product-slide-img">
                                    <div class="font-weight-bold product-details">{{ p.name }}</div>
                                    <div class="product-details" v-if="p.price && p.price.UnitPrice">{{ p.price.UnitPrice }}$</div>
                                </div>
                            </router-link>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {Carousel, Slide} from 'vue-carousel';

  export default {
    name: 'you-might-also-like',
    components: {
      Carousel,
      Slide,
    },
    props: ['products'],
    computed: {
      ...mapState('willyou', [
        'currentStore',
      ]),
    },
  }
</script>

<style lang="scss" scoped>
    #you-might-also-like {

    .carousel-title {
        font-size: 14px;
        font-family: 'Noto Sans KR', sans-serif;
        color: #4a4a4a;
    }

    .product-details {
        font-size: 16px;
        font-family: 'Noto Sans KR', sans-serif;
        color: #4a4a4a;

    }

    .vue-carousel-area {
        max-width: 700px;
    }

    .carousel-element-area {

    .product-slide-img {
        width: 200px;
        height: auto;
    }

    }
    }
</style>